import { useEffect, useRef, useState } from "react";
import type { ChargerChoiceConfig } from "../scenario/types";
import { ChoiceCard, ChoiceList } from "../ui/ChoiceCard";
import { audio } from "../lib/audio";
import { tx } from "../lib/tx";

export function ChargerChoice({
  config,
  onChoose,
}: {
  config: ChargerChoiceConfig;
  onChoose: (opt: ChargerChoiceConfig["options"][number]) => void;
}) {
  const [goblin, setGoblin] = useState(false);
  const spoke = useRef(false);

  useEffect(() => {
    // Prefetch every line this device can speak so the voice pre-render captures branch lines.
    if (config.lenaRisky) void audio.prefetchSpeech(config.lenaRisky, { voice: "nova", lang: config.language ?? "en-US" });
    if (config.lenaSafe) void audio.prefetchSpeech(config.lenaSafe, { voice: "nova", lang: config.language ?? "en-US" });
    if (spoke.current) return;
    spoke.current = true;
    void audio.speak(config.body ?? "Battery low. How should Max charge?", {
      voice: config.voiceId ?? "onyx",
      lang: config.language ?? "en-US",
    });
    return () => audio.cancelSpeech();
  }, [config]);

  return (
    <div className="rw-panel chargerchoice">
      <div className="rw-kicker">{tx("Café · low battery")}</div>
      <h2>{config.headline ?? tx("The charger of doom")}</h2>
      {config.body && <p className="rw-body">{config.body}</p>}
      {goblin && (
        <div className="rw-goblin" aria-live="polite">
          <div className="rw-goblin-art" aria-hidden />
          <p>{config.goblinCaption ?? tx("Data goblin activated. Files are leaving the building.")}</p>
        </div>
      )}
      <ChoiceList prompt={tx("How should Max charge his phone?")}>
        {config.options.map((o) => (
          <ChoiceCard
            key={o.id}
            category={o.category}
            showRiskLabel={false}
            reply={o.label}
            onClick={() => {
              if (o.goblin) {
                setGoblin(true);
                if (config.lenaRisky)
                  void audio.speak(config.lenaRisky, {
                    voice: "nova",
                    lang: config.language ?? "en-US",
                  });
                window.setTimeout(() => onChoose(o), 1200);
                return;
              }
              if (o.safe && config.lenaSafe)
                void audio.speak(config.lenaSafe, {
                  voice: "nova",
                  lang: config.language ?? "en-US",
                });
              onChoose(o);
            }}
          />
        ))}
      </ChoiceList>
    </div>
  );
}
